<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <p>{{ data.description }}</p>

  <mat-form-field appearance="outline">
    <mat-label>{{ data.label }}</mat-label>

    <input
      required
      matInput
      [placeholder]="data.placeholder"
      [value]="selectedItem()?.title || null"
      [matAutocomplete]="auto"
      (input)="this.selectedItem.set(null)"
      (keydown.enter)="onSearchEvent($event)"
    />

    <mat-hint>Press enter to search.</mat-hint>

    @if (!resource.isLoading()) {
      <mat-icon matSuffix>search</mat-icon>
    } @else {
      <mat-spinner diameter="24" style="margin: 12px" matSuffix></mat-spinner>
    }

    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="selectedItem.set($event.option.value)"
    >
      @if (resource.hasValue()) {
        @for (item of resource.value().items; track item.id) {
          @if (item.number || item.area) {
            <mat-option [value]="item"
              >[ {{ item.number || item.area }} ] {{ item.title }}</mat-option
            >
          } @else {
            <mat-option [value]="item">{{ item.title }}</mat-option>
          }
        }
      }
    </mat-autocomplete>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button [mat-dialog-close]="selectedItem()" [disabled]="selectedItem() === null">
    Add
  </button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
